/*=============================================== Alert ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import { P } from "./Font";
import Mixins from "./Mixins";
/*==================== Component ====================*/
var Alert = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "primary" : _b, children = _a.children, modal = _a.modal, props = __rest(_a, ["color", "children", "modal"]);
    return (React.createElement(Container, __assign({ "$color": color, as: typeof children === "string" ? P : "div", "$modal": modal }, props), children));
};
export default Alert;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n    padding: ", ";\n    width: ", ";\n    max-width: ", ";\n    background-color: ", ";\n    border: 1px solid\n        ", ";\n    border-radius: ", ";\n"], ["\n    color: ", ";\n    ", ";\n    padding: ", ";\n    width: ", ";\n    max-width: ", ";\n    background-color: ", ";\n    border: 1px solid\n        ", ";\n    border-radius: ", ";\n"])), function (_a) {
    var $color = _a.$color;
    return ($color === "black" ? Variables.Colors.White : Variables.Colors.Black);
}, Mixins.Grid({
    $gap: "s",
}), Variables.Spacers.M, function (_a) {
    var $modal = _a.$modal;
    return $modal && "100%";
}, function (_a) {
    var $modal = _a.$modal;
    return $modal && "400px";
}, function (_a) {
    var $color = _a.$color;
    return $color === "secondary"
        ? Variables.Colors.Secondary50
        : $color === "success"
            ? Variables.Colors.Success50
            : $color === "danger"
                ? Variables.Colors.Danger50
                : $color === "warning"
                    ? Variables.Colors.Warning50
                    : $color === "gray"
                        ? Variables.Colors.Gray50
                        : $color === "black"
                            ? Variables.Colors.Gray800
                            : $color === "white"
                                ? Variables.Colors.Gray50
                                : Variables.Colors.Primary50;
}, function (_a) {
    var $color = _a.$color;
    return $color === "secondary"
        ? Variables.Colors.Secondary500
        : $color === "success"
            ? Variables.Colors.Success500
            : $color === "danger"
                ? Variables.Colors.Danger500
                : $color === "warning"
                    ? Variables.Colors.Warning500
                    : $color === "gray"
                        ? Variables.Colors.Gray500
                        : $color === "black"
                            ? Variables.Colors.Black
                            : $color === "white"
                                ? Variables.Colors.White
                                : Variables.Colors.Primary500;
}, Variables.Radiuses.M);
var templateObject_1;
